import { TextResources, ConfigData } from '../config/StoreLocatorTextResources';
import { STORELOCATORCOMPONENT } from '../components/storelocator.component';
import { LOCATIONCOMPONENT } from '../components/location.component';
import { ORDERATHOME } from '../components/orderathome.component';
import { HEADLINE } from '../components/headline.component';
import { GOOGLEMAPSERVICE } from './google.map.service';
import { ROUTE } from './route.directions.service';
import { MARKER } from './google.marker.service';
import { NOMINATIM } from './nominatim.service';
import { IMAGEVIEW } from './imageview.service';
import { URLSERVICE } from './url.service';
import { HELPER } from './helper.service';
import { XTCI } from './xtci.service';

export class SingleLocationService {
  /**
   * Propertys
   */
  location: Element;
  mapContent: Element;
  mapLocation: Element;
  sidebar?: Element;

  xtciRequest() {
    let responseXML: object;
    const location_xml = XTCI.createXML(
      'locationlist_request',
      STORELOCATORCOMPONENT.getRequestData('locationlist_request'),
    ) as Document;

    XTCI.executeRequest(
      location_xml,
      (response_xml) => {
        responseXML = response_xml;
        const getCity = this.getCity(responseXML);
        STORELOCATORCOMPONENT.currentCity = getCity;

        const requestParameter = `${'?q=' + getCity + '&countrycodes=' + this.getIsoCountry(response_xml) + '&limit=1'}`;
        NOMINATIM.executeRequest(requestParameter, (callback) => {
          if (callback.length > 0) {
            const callbackCoords = { lat: Number(callback[0].lat), lng: Number(callback[0].lon) };
            ROUTE.geoCoords = callbackCoords;
            GOOGLEMAPSERVICE.initMap();
            this.getPlaceDetails(responseXML);
          }
        });
      },
      STORELOCATORCOMPONENT.displayNoticeOverlay,
      TextResources.resources['error'].location,
    );

    STORELOCATORCOMPONENT.requestDataLocation = {};
    return responseXML;
  }

  displayLocationsDetails() {
    this.mapContent =
      STORELOCATORCOMPONENT.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-content');
    this.mapLocation =
      STORELOCATORCOMPONENT.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-location');
    this.sidebar =
      STORELOCATORCOMPONENT.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-map-sidebar');
    this.location = STORELOCATORCOMPONENT.storeLocatorHtmlElement.shadowRoot.querySelector<HTMLElement>('cwc-location');

    this.displaySingleLocation();
  }

  getCity(responseXML) {
    const city = responseXML.querySelector('locationlist > content > location > city');
    return city.textContent;
  }

  getIsoCountry(responseXML) {
    const iso_country = responseXML.querySelector('locationlist > content > location > iso_country');
    return iso_country.textContent.toLowerCase();
  }

  getPlaceDetails(responseXML) {
    LOCATIONCOMPONENT.currentLocations = LOCATIONCOMPONENT.placeLocations(responseXML);

    this.displayLocationsDetails();

    STORELOCATORCOMPONENT.geoCoords = ROUTE.geoCoords;
    MARKER.handleMarkers(LOCATIONCOMPONENT.currentLocations);
  }

  displaySingleLocation() {
    this.sidebar.remove();
    this.mapContent.classList.add('single-location');
    if (ConfigData.data['showOrderAtHomeButton'] || ConfigData.data['showGetDirectionsButton']) {
      ORDERATHOME.createOrderAtHomeButton(this.location);
    }

    const backToLocationsButton = this.location.querySelector('cwc-location button.back-to-locations');
    if (backToLocationsButton) {
      backToLocationsButton.addEventListener('click', () => {
        if (ConfigData.data['receiveParameters'] || !ConfigData.data['currentCity']) {
          window.location.href = URLSERVICE.getlandingPageURL() + '?s=' + STORELOCATORCOMPONENT.currentCity;
        } else if (ConfigData.data['currentCity']) {
          const url = new URL(document.location.href);

          if (url.searchParams.has('locid')) {
            url.searchParams.delete('locid');
            window.location.href = url.href;
          }
        } else {
          window.location.href = URLSERVICE.getlandingPageURL();
        }
      });
    }

    if (!ConfigData.data['hideLocationImages']) {
      const imageContent = this.location.querySelector<HTMLElement>('.img-items');
      const mapImagesObject = document.createElement('cwc-map-images');
      mapImagesObject.appendChild(imageContent);
      this.mapContent.appendChild(mapImagesObject);

      IMAGEVIEW.getLocationImagesItems(imageContent);

      // create a container for the product image preview
      const hasCwcProductImages = this.mapContent.querySelector('cwc-product-images') as HTMLElement;
      const productImagesContainer = hasCwcProductImages
        ? hasCwcProductImages
        : (document.createElement('cwc-product-images') as HTMLElement);
      if (!hasCwcProductImages) {
        // add product images container to cwc-map-content
        this.mapContent.appendChild(productImagesContainer);
      }
      IMAGEVIEW.createImageCarousel(imageContent, productImagesContainer, false);
    }
    if (ConfigData.data['headlineSingle']) {
      HEADLINE.createHeadline(this.location, ConfigData.data['headlineSingle'], 'single');
    }
    this.handleButtonItinerary(this.location);
  }

  handleButtonItinerary(element) {
    const locationInfo = element.querySelector('div.info-content');
    const locationItinerary = element.querySelector('cwc-location-itinerary');
    const buttonItinerary = element.querySelector('cwc-button-itinerary');
    const itinerary = this.createButtonItinerary();
    buttonItinerary.appendChild(itinerary);

    const backButton = STORELOCATORCOMPONENT.createBackButton(TextResources.resources['location'].control.back);
    backButton.addEventListener('click', () => {
      ConfigData.data['calculateRoute'] = false;
      HELPER.toggleTwoClasses(locationInfo, 'show', 'hide');
      HELPER.toggleTwoClasses(locationItinerary, 'hide', 'show');

      ROUTE.resetDirectionsMap();
      ROUTE.centerMapOnCurrentLocation();
      ROUTE.clearTravelMode();
    });
    locationItinerary.prepend(backButton);

    itinerary.addEventListener('click', () => {
      if (!locationInfo.classList.contains('hide') && !locationInfo.classList.contains('show')) {
        locationInfo.classList.add('hide');
      } else {
        HELPER.toggleTwoClasses(locationInfo, 'show', 'hide');
      }
      if (!locationItinerary.classList.contains('show') && !locationItinerary.classList.contains('hide')) {
        locationItinerary.classList.add('show');
      } else {
        HELPER.toggleTwoClasses(locationItinerary, 'hide', 'show');
      }
      ConfigData.data['calculateRoute'] = true;
      ROUTE.handleRouteCalculation(element);
    });
  }

  createButtonItinerary() {
    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'sg-cw-button sg-cw-raise';
    button.textContent = TextResources.resources['location'].control.calculate_route;

    return button;
  }
}

export const SINGLELOCATIONSERVICE = new SingleLocationService();
